import React, {FC, ReactNode} from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import {BoxProps, withStyles} from '@material-ui/core';
import {Guideline} from '@epic-ui/icons';

import {Tooltip} from '..';

const HeaderContainer = withStyles<string, undefined, BoxProps>(theme => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(3),
        minHeight: theme.spacing(8)
    }
}))(Box);

export interface StatisticsPanelProps {
    title: string;
    tooltip: JSX.Element | string;
    actions?: ReactNode;
    children?: ReactNode;
}

const StatisticsPanel: FC<StatisticsPanelProps> = ({
    title,
    tooltip,
    actions,
    children
}: StatisticsPanelProps) => (
    <Box width="100%">
        <HeaderContainer>
            <Box display="flex" alignItems="center">
                <Typography variant="body2">{title}</Typography>
                <Tooltip placement="top" title={tooltip}>
                    <Box mx={1.5} display="flex" alignItems="center">
                        <Guideline />
                    </Box>
                </Tooltip>
            </Box>
            {actions}
        </HeaderContainer>
        {children}
    </Box>
);

export default StatisticsPanel;
